import styled from "styled-components";
import { Dispatch, SetStateAction } from "react";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ProductSearchHistory } from "../../components/history/ProductSearchHistory";
import SearchBarComponent from "../../components/search-component/SearchBarComponent";
import { SearchResults } from "../../components/searchResults/SearchResults";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";

const ARTICLE_NUMBER_LENGTH = 8;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

interface ProductSearchPagePresentationProps {
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  handleClose: () => void;
  shouldHideSPRItems: boolean;
  shouldHideLocalCombinationItems: boolean;
  handleItemCardClick?: (item: Item) => void;
  itemCardRenderType?: SearchItemCardRenderType;
  shouldShowCloseButton?: boolean;
  shouldHideHistory?: boolean;
}

export const ProductSearchPagePresentation = ({
  searchQuery,
  setSearchQuery,
  handleItemCardClick = () => {},
  handleClose,
  shouldShowCloseButton = false,
  shouldHideSPRItems,
  itemCardRenderType = SearchItemCardRenderType.link,
  shouldHideLocalCombinationItems,
  shouldHideHistory = false,
}: ProductSearchPagePresentationProps) => {
  return (
    <Container>
      <SearchBarComponent
        onSearchBarClick={() => {}}
        handleSearchQueryChange={(e) => {
          let value = e.target.value;
          // To handle scan from search input
          // If the value is all digits and longer than 8, slice to 8 digits (article number)
          if (value.length > ARTICLE_NUMBER_LENGTH && /^\d+$/.test(value)) {
            value = value.slice(0, ARTICLE_NUMBER_LENGTH);
          }
          setSearchQuery(value);
        }}
        onSearchQueryReset={() => {
          setSearchQuery("");
        }}
        searchQuery={searchQuery}
        onCloseSearchClick={handleClose}
        shouldShowCloseButton={shouldShowCloseButton}
        autoFocus
      />
      {!shouldHideHistory && (
        <ProductSearchHistory
          hideHistory={searchQuery.length > 0}
          setSearchQuery={setSearchQuery}
        />
      )}
      <SearchResults
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleItemCardClick={handleItemCardClick}
        itemCardRenderType={itemCardRenderType}
        shouldHideSPRItems={shouldHideSPRItems}
        shouldHideLocalCombinationItems={shouldHideLocalCombinationItems}
      />
    </Container>
  );
};
